import React from 'react';
interface BadgeProps {
  children: React.ReactNode;
  color?: string;
  className?: string;
}
export function Badge({
  children,
  color = '#0969da',
  className = ''
}: BadgeProps) {
  return <span className={`inline-flex items-center text-xs text-[#57606a] ${className}`} data-id="element-229">
      <span className="w-3 h-3 rounded-full mr-1.5 border border-black/10" style={{
      backgroundColor: color
    }} data-id="element-230" />
      {children}
    </span>;
}